import React, { Fragment, useState, useEffect } from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import { fetchDataActive, postData, fetchData, fetchData1, fetchEventincomeExpenseData, updateData, fetchEventincomeExpenseDataFull, fetchDataAccountsIncomeExpense } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import { TableCell, TableContainer, Tooltip, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';
//import Modal from 'react-modal';


const PREdit = (props) => {


    const history = useHistory();

    const { isAuthenticated, clubId, branchId, userId, logout, token } = useAuth();
    // const [billNo, setBillNo] = useState("");
    //const [billDate, setBillDate] = useState("");
    //const [amount, setAmount] = useState("");
    const [ispaymentnew, setIsPayment] = useState(true);
    //const [ischeck, setIsCheck] = useState(false);
    //const [type, setType] = useState("");
    // const [incomeexpenseid, setIncomeExpenseId] = useState("");
    // const [EventIdNew, setEventId] = useState("");
    // const [memberId, setMemberId] = useState("");
    const [dues, setDues] = useState("");
    //  const [feesId, setFeesDescriptionId] = useState("");
    const [partId, setPartyId] = useState("");
    const [description, setDescription] = useState("");
    const [paymenttype, setPaymentType] = useState("0");
    const [chequeNo, setChequeNo] = useState("");
    const [chequeDate, setChequeDate] = useState("");
    // const [bankId, setBankId] = useState("");
    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSave, setIsSave] = useState(false);
    const [memberOptions, setMemberOptions] = useState([]);
    const [selectedMember, setSelectedMember] = useState(""); // Store selected member ID
    const [eventslist, setEventOptions] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(""); // Store selected member ID
    const [incomelist, setIncomeOptions] = useState([]);
    const [expenselist, setExpenseOptions] = useState([]);
    const [childdata, setFormchildData] = useState([]);
    const [eventincomelist, setEventIncomeOptions] = useState([]);
    const [eventexpenselist, setEventExpenseOptions] = useState([]);
    const [feeslist, setFeesOptions] = useState([]);
    const [selectedfees, setSelectedFees] = useState("");
    const [partylist, setPartyOptions] = useState([]);
    const [selectedParty, setSelectedParty] = useState("");
    const [banklist, setBankOptions] = useState([]);
    const [selectedbank, setSelectedBank] = useState("");
    const [searchTerm, setSearchTerm] = useState(''); // New state for the search term
    const [selectedOption, setSelectedOption] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { id } = useParams();
    const { eventidnewid } = useParams();
    const [isIdValid, setIsIdValid] = useState(true);
    const [clubIncomeExpenseOption, setClubIncomeExpenseOption] = useState(null); // For Club Income/Expense
    const [eventHeadOption, setEventHeadOption] = useState(null); // For Event Head
    const [eventIncomeExpenseOption, setEventIncomeExpenseOption] = useState(null);
    // Options for the dropdown
    const options = [
        { value: 1, label: 'Club Income/Expense' },
        { value: 2, label: 'Club Event' },
        { value: 3, label: 'Members' },
        { value: 4, label: 'Others' },
    ];
    const optionsn = [];
    // Options for the dropdown
    const paymentoptions = [
        { value: 0, label: 'Cash' },
        { value: 1, label: 'Cheque' },
        { value: 2, label: 'UPI' },

    ];
    // Use effect to fetch bank list when ischeck becomes true
    useEffect(() => {
        if (paymenttype == 1 || paymenttype == 2) {
            fetchBank();
        }
    }, [paymenttype]); // Only runs when ischeck changes


    const [formData, setFormData] = useState({
        billNo: '',
        billDate: '',
        amount: '',
        isPayment: '',
        type: '',
        incomeOrExpenseId: '',
        eventId: '',
        memberId: '',
        dues: '',
        feesDescriptionId: '',
        partyId: '',
        Description: '',
        chequeNo: '',
        chequeDate: '',
        bankId: '',
        createdBy: '',
        createdDate: '',
        ModifiedBy: '',
        ModifiedDate: '',
        clubId: '',
        id: '',
        eventIncomeExpense: '',
        clubIncomeExpense: '',
        event: '',
        member: '',
        party: '',
        fees: '',
        bank: ''
    });



    // State to control when `fetchEventExpenseData` should run
    const [shouldFetchExpenseData, setShouldFetchExpenseData] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        if (id) {
            fetchData('PaymentAndReceiptApi', `/GetPaymentAndReceiptDetails/${id}`, token)
                .then((response) => {
                    if (response.responseCode === '1111') {
                        const Datas = response.response_data.prMasterData;
                        const child = response.response_data.prChildData;
                        setFormchildData(child);
                        setFormData(prevState => ({
                            ...prevState,
                            ...Datas,
                            ModifiedBy: userId,
                            isPayment: Datas.isPayment, // Ensure this is properly set
                            eventId: Datas.eventId,    // Ensure this is properly set
                        }));
                        const eventOptions = response.response_data.eventincomeexpenselist.map(item => ({
                            value: item.id,
                            label: item.description,
                            isIncome: item.isIncome,
                            eventId: item.eventId,

                        }));
                        setEventExpenseOptions(eventOptions);

                        const evoptions = response.response_data.eventlist.map(events => ({
                            value: events.id,
                            label: events.event,
                        }));
                        setEventOptions(evoptions);

                        const feesoptions = response.response_data.feeslist.map(fees => ({
                            value: fees.id,
                            label: fees.feesDescription,

                        }));
                        setFeesOptions(feesoptions);
                        const clubexpenseoptionsn = response.response_data.accountsList.map(incomeexpense => ({
                            value: incomeexpense.id,
                            label: incomeexpense.head,

                        }));

                        setExpenseOptions(clubexpenseoptionsn);
                        const partyoptions = response.response_data.personlist.map(party => ({
                            value: party.id,
                            label: party.name,

                        }));
                        fetchBank();
                        setPartyOptions(partyoptions);
                        setShouldFetchExpenseData(true);
                        fetchtableDataEvent();
                        fetchFees();
                        fetchMember();
                        fetchEventExpenseData();
                        setIsPayment(response.response_data.prMasterData.isPayment)
                        setSelectedOption(response.response_data.prMasterData.type);
                        setSearchTerm(response.response_data.prMasterData.member);
                        setPaymentType(response.response_data.prMasterData.paymentType);
                        setSelectedBank(response.response_data.prMasterData.bankid)

                        // Trigger the fetch for event expense data
                        setShouldFetchExpenseData(true);
                    } else {
                        setIsIdValid(false);
                        setErrorMessage('Invalid ID. No record found.');
                    }
                })
                .catch((error) => {
                    console.error('Error fetching Payment Details:', error);
                    setIsIdValid(false);
                    setErrorMessage('Failed to fetch Payment details.');
                });
        } else {
            setIsIdValid(false);
            setErrorMessage('Invalid ID. Please try again.');
        }
    }, [id, isAuthenticated, token, logout]);



    useEffect(() => {
        // Only fetch event expense data if necessary fields are available
        if ((formData.isPayment === true || formData.isPayment === false) && formData.eventId !== "") {
            fetchEventExpenseData();
        }
    }, [formData.isPayment, formData.eventId]);  // Watch for changes in payment status or eventId




    const fetchEventExpenseData = async () => {//new
        try {
            const eventresponse = await fetchEventincomeExpenseDataFull(
                'EventApi',
                `/${clubId}`,
                `/${branchId}`,
                token
            );

            if (eventresponse.responseCode === '1111') {


                const eventOptions = eventresponse.response_data.map(item => ({
                    value: item.id,
                    label: item.description,
                    isIncome: item.isIncome,
                    eventId: item.eventId,

                }));
                setEventExpenseOptions(eventOptions);
            } else {
                console.warn('Unexpected response code:', eventresponse.responseCode);
            }
        } catch (error) {
            console.error('Error fetching event data:', error);

            if (error.response && error.response.status === 401) {
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            } else {
                console.error('An unexpected error occurred.');
            }
        }
    };

    // Fetch Event Table Data
    const fetchtableDataEvent = async () => {
        try {
            const response = await fetchData('EventApi', `/${branchId}`, token);
            if (response.responseCode === '1111') {
                const evoptions = response.response_data.map(events => ({
                    value: events.id,
                    label: events.event,
                }));
                setEventOptions(evoptions);
            }
        } catch (error) {
            console.error('Error fetching Event Details:', error);
        }
    };


    const handleSubmit
        = async (e) => {
            e.preventDefault();

            const PaymentAndReceipts = {
                Id: formData.id,
                BillNo: formData.billNo || null,  // Pass null if lastname is falsy
                BillDate: formData.billDate || null,  // Pass null if firstname is falsy
                Amount: formData.amount || null,  // Null if weddinganniversary is falsy
                IsPayment: formData.isPayment,  // Null if dateofjoining is falsy
                Type: formData.type || null,  // Null if dateofbirth is falsy
                IncomeOrExpenseId: formData.incomeOrExpenseId || null,  // Null if phonenumber is falsy
                EventId: formData.eventId || null,  // Null if email is falsy
                MemberId: formData.memberId || null,  // Null if remark is falsy
                Dues: formData.dues, // Null if userId is falsy (unlikely for userId)
                FeesDescriptionId: formData.feesDescriptionId,  // Always generate the current date
                PartyId: formData.partyId,
                Description: formData.description,
                ChequeNo: formData.chequeNo,
                IsActive: true,  // Null if gender is falsy
                ChequeDate: formData.chequeDate, // Null if clubId is falsy
                CreatedDate: formData.createdDate, // Default to 4 (doesn't need a null check)
                ModifiedDate: new Date(),
                BankId: formData.bankId,
                IsCheque: formData.isCheque,
                ModifiedBy: userId,
                FinancialYear: formData.createdDate,

                Bank: formData.bank || '',
                Event: formData.event || '',
                Member: formData.member || '',
                Party: formData.party || '',
                clubIncomeExpense: formData.clubIncomeExpense || '',
                eventIncomeExpense: formData.eventIncomeExpense || '',
                Fees: formData.fees || '',

            };



            try {
                const response = await updateData('PaymentAndReceiptApi', id, PaymentAndReceipts, token);
                console.log('Record updated successfully:', response);

                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);

                history.push('/CIndex');

            } catch (error) {
                console.error('Error updating record:', error);
            }
        };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleOptionChange = (option) => {
        // Update formData with the selected option
        setFormData((prev) => ({
            ...prev,
            type: option, // Update 'type' in formData
        }));

        // Perform actions based on the selected option
        if (option.value === 1) {
            fetchtableData(); // Fetch table data
            setSelectedEvent(""); // Reset event selection
            setSelectedDropdownOption(""); // Reset dropdown selection
        }
        else if (option.value === 2) {
            fetchtableDataEvent(); // Fetch event-specific data
            setExpenseOptions(""); // Reset expense options
            setIncomeOptions(""); // Reset income options
            setSelectedDropdownOption(""); // Reset dropdown selection
        }
        else if (option.value === 3) {
            setExpenseOptions(""); // Reset expense options
            setIncomeOptions(""); // Reset income options
            setSelectedDropdownOption(""); // Reset dropdown selection
            setSelectedEvent(""); // Reset event selection
            fetchMember(); // Fetch members
            setSelectedMember(""); // Reset member selection
        }
        else if (option.value === 4) {
            fetchParty(); // Fetch party data
        }
    };

    const handleAddClick = () => {
        // setIsModalOpen(true);
    };

    const handleDropdownChange = (dropdownOption) => {
        if (selectedOption?.value === 2) {
            setEventHeadOption(true); // Event Head
            //fetchEventExpenseData(dropdownOption.value); // Fetch Event Income/Expense
            //setEventIncomeExpenseOption(null); // Reset Event Income/Expense
        }
    };

    const handleDropdownChange1 = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : null;
        setFormData({ ...formData, incomeOrExpenseId: selectedValue });
    };

    const handleFeesChange = (event) => {
        //setSelectedFees(dropdownOption);
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleBankChange = (dropdownOption) => {
        setSelectedBank(dropdownOption);
    };

    const handlePartyChange = (dropdownOption) => {
        setSelectedParty(dropdownOption);
    };

    const handleDropdownChangeEvent = (dropdownOption) => {
        setSelectedEvent(dropdownOption);

    };

    const handleIncomeExpenseChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value, // Update gender based on the selected value
        }));
    };

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user

            logout();
            return;
        }

    }, [isAuthenticated, clubId, token, logout]);

    useEffect(() => {
        fetchtableData();
    }, []);

    const fetchtableData = async () => {
        try {
            const response = await fetchDataAccountsIncomeExpense('AccountHeadApi', `/${clubId}`, formData.isPayment, token);
            if (response.responseCode === '1111') {
                const optionsn = response.response_data.map(incomeexpense => ({
                    value: incomeexpense.id,
                    label: incomeexpense.head,

                }));
                if (formData.isPayment) {
                    setExpenseOptions(optionsn);  // Store in expense list
                } else {
                    setIncomeOptions(optionsn);   // Store in income list
                }

            }



            else {
                console.warn('Unexpected response code:', response.responseCode);
                // Handle other response codes if needed
            }
        } catch (error) {
            console.error('Error fetching AccountHead Details:', error);

            // Handle unauthorized error
            if (error.response && error.response.status === 401) {
                //logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            } else {
                // Handle other errors, if any
                console.error('An unexpected error occurred.');
            }
        }
    };

    const clearForm = () => {
        // setBillNo(""); setBillDate("");
        //  setAmount(""); setIsPayment("");
        // setType(""); setIncomeExpenseId("");
        //  setEventId(""); setMemberId("");
        //  setDues("");
        ///  setFeesDescriptionId(""); setPartyId("");
        //  setDescription(""); setChequeNo("");
        //  setChequeDate(""); setBankId("");
        //  setMemberOptions(""); setSelectedMember("");
        //  setEventOptions("");
        // setSelectedEvent("");
        // setFeesOptions("");
        // setSelectedFees("");
        // setPartyOptions(""); setSelectedParty("");
        //  setBankOptions(""); setSelectedBank("");


    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setIsSubmit(true);
        // submitData(e);

    }

    const [memberList, setMemberList] = useState([]);
    const [showTable, setShowTable] = useState(false);

    const fetchMember = async () => {
        try {

            const response = await fetchData1('MemberApi', `/${clubId}/${branchId}`, token);
            // const response = await fetchData1('MemberApi', params1, params2, token);

            if (response.responseCode === '1111') {

                const options = response.response_data.map(member => ({
                    value: member.id,
                    label: member.firstName,
                    fullName: `${member.firstName} ${member.lastName}`,
                    phoneNumber: member.phoneNumber,
                    email: member.email,

                }));
                setMemberOptions(options);
                setMemberList(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Member:', error);
        }
    };

    const handleRowClick = (member) => {
        const selectedOption = { value: member.id, label: `${member.firstName} ${member.lastName}` };
        setSelectedMember(selectedOption);
        setSearchTerm(selectedOption.label); // Display the selected name in the search box
        setIsModalOpen(false); // Close modal after selecting a member
    };

    // const filteredMembers = memberList.filter((member) =>
    //     `${member.firstName} ${member.lastName}`.toLowerCase().includes(searchTerm.toLowerCase())
    // );

    const filteredMembers = (memberList || []).filter((member) => {
        const fullName = `${member.firstName || ''} ${member.lastName || ''}`;
        return fullName.toLowerCase().includes((searchTerm || '').toLowerCase());
    });

    const fetchFees = async () => {
        try {
            const response = await fetchData('ClubFeesApi', `/${clubId}`, token)
            if (response.responseCode === '1111') {

                const options = response.response_data.map(fees => ({
                    value: fees.id,
                    label: fees.feesDescription,

                }));
                setFeesOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Fees:', error);
        }
    };

    const fetchParty = async () => {
        try {
            const response = await fetchData('PersonApi', `/${clubId}`, token)
            if (response.responseCode === '1111') {

                const options = response.response_data.map(party => ({
                    value: party.id,
                    label: party.name,

                }));
                setPartyOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Fees:', error);
        }
    };

    const fetchBank = async () => {
        try {
            const response = await fetchData('PersonApi', `/${clubId}`, token);

            if (response.responseCode === '1111') {
                const bankoptions = response.response_data
                    .filter(party => party.isBank === true) // Filter for items where isBank is true
                    .map(party => ({
                        value: party.id,
                        label: party.name,
                    }));

                setBankOptions(bankoptions);
            }
        } catch (error) {
            console.error('Error fetching Fees:', error);
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setIsModalOpen(true); // Open modal when typing in the search box
        fetchFees();
    };

    const handleMemberChange = (dropdownOption) => {
        setSelectedMember(dropdownOption);
        fetchFees();
        setIsModalOpen(true); // Open modal when dropdown changes
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return ''; // Handle cases where dateString is undefined or null
        const currentDate = new Date(dateString);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    //const closeModal = () => setIsModalOpen(false);
    const [selectedDropdownOption, setSelectedDropdownOption] = useState(null);

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '95%' }}>
                <form onSubmit={handleFormSubmit}>
                    <div className="w-full flex justify-between items-center flex-wrap">
                        {/* Heading on the left */}
                        <h6 className='productHead linkcolor'
                            style={{ color: 'black', padding: '7px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                            Payment & Receipts
                        </h6>
                        <div className="w-1/10 mr-2">
                            <div className="flex items-center">
                                <input
                                    type="radio"
                                    id="payment"
                                    name="entityTypeEdit"
                                    value="payment"
                                    checked={formData.isPayment === true}
                                    onChange={() =>
                                        setFormData({ ...formData, isPayment: true, selectedOption: "" })
                                    }
                                />
                                <label htmlFor="onetimeEdit" className="ml-2">Payment</label>

                                <input
                                    type="radio"
                                    id="receipt"
                                    name="entityTypeEdit"
                                    value="receipt"
                                    checked={formData.isPayment === false}
                                    onChange={() =>
                                        setFormData({ ...formData, isPayment: false, selectedOption: "" })
                                    }
                                    className="ml-4"
                                />
                                <label htmlFor="ispayment" className="ml-2">Receipt</label>
                            </div>
                        </div>
                        {/* Buttons on the right */}
                        <div className="flex mt-2">
                            <Button onClick={handleSubmit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c' }}>
                                Save
                            </Button>
                            <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c', marginLeft: '5px' }}>
                                <Link to="/PRIndex" className="linkcolor" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    CANCEL
                                </Link>
                            </Button>
                        </div>
                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full flex flex-wrap">
                        {/* <div className="w-full sm:w-3/5"> */}
                        <div className="w-full mb-2 flex">
                            <div className="w-1/8 mr-2" style={{ width: '100px' }}>
                                <label htmlFor="billNo">Bill No</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    name="billNo"
                                    value={formData.billNo}
                                    onChange={handleInputChange}
                                    type="text"
                                    placeholder="Enter Bill No"
                                />
                            </div>
                            <div className="w-1/10 mr-2">
                                <label htmlFor="billDate">Bill Date</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                    name="billDate"

                                    value={formatDateForInput(formData.billDate)}

                                    onChange={handleInputChange}
                                    type="date"
                                    placeholder="Select Bill Date"
                                />
                            </div>
                            <div className="w-1/10 mr-2">
                                <label htmlFor="amount">Amount</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right readonly"
                                    name="amount"
                                    value={formData.amount}
                                    onChange={handleInputChange}
                                    type="text"
                                    placeholder="Enter Amount"
                                    readOnly
                                    isDisabled
                                />
                            </div>

                        </div>


                        <div className="w-full flex flex-wrap">

                            <div className="w-full mb-4 flex">

                            </div>

                            <div className="w-1/10 mr-2">
                                <label htmlFor="clubOptions">Club Options</label>
                                <Select
                                    value={options.find((opt) => opt.value === selectedOption)}
                                    options={options} // Provide options
                                    placeholder="Select an option"
                                    isSearchable
                                    isDisabled // Set as read-only (disabled)
                                />
                            </div>




                            {(selectedOption === 1) && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="clubOptions" style={{ fontSize: '16px' }}>
                                        Select Club Income Expense Head

                                    </label>
                                    <div className="flex items-center">
                                        <Select
                                            value={expenselist.find((opt) => opt.value === formData.incomeOrExpenseId) || null}
                                            onChange={handleDropdownChange1}
                                            options={expenselist}
                                            placeholder="Select an option"
                                            isSearchable

                                        />
                                    </div>
                                </div>
                            )}

                            {(selectedOption?.value === 2) && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="clubOptions" style={{ fontSize: '16px' }}>
                                        Event Income Expense Head
                                    </label>
                                    <div className="flex items-center">
                                        <Select
                                            value={expenselist.find((opt) => opt.value === formData.incomeOrExpenseId) || null}
                                            onChange={handleDropdownChange1}
                                            options={expenselist}
                                            placeholder="Select an option"
                                            isSearchable
                                        />
                                    </div>
                                </div>
                            )}

                            {selectedOption === 2 && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="eventHead">Select Event</label>
                                    <Select
                                        value={formData.eventId ? eventslist.find(option => option.value === formData.eventId) : null}  // Find the selected value
                                        onChange={(selectedOption) => {
                                            // Update the formData with the selected eventId
                                            setFormData(prevData => ({
                                                ...prevData,
                                                eventId: selectedOption ? selectedOption.value : null
                                            }));

                                            //fetchEventExpenseData(selectedOption ? selectedOption.value : null);
                                        }}
                                        options={eventslist}
                                    />
                                </div>
                            )}


                            {selectedOption === 2 && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="eventIncomeExpense">
                                    </label>

                                    <Select
                                        value={formData.incomeOrExpenseId ? eventexpenselist.find(option => option.value === formData.incomeOrExpenseId) : null}
                                        onChange={(selectedOption) => {
                                            setFormData(prevData => ({
                                                ...prevData,
                                                incomeOrExpenseId: selectedOption ? selectedOption.value : null
                                            }));


                                        }}
                                        // options={eventexpenselist}
                                        options={eventexpenselist.filter(item =>
                                            formData.isPayment
                                                ? !item.isIncome && item.eventId === formData.eventId
                                                : item.isIncome && item.eventId === formData.eventId
                                        )}
                                    />
                                </div>
                            )}



                            {formData.type === 3 && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="amount">Select Member</label>
                                    <div className="flex items-center">
                                        <input
                                            type="text"
                                            id="searchMember"
                                            value={searchTerm || formData.member || ""}
                                            onChange={handleSearchChange}
                                            placeholder="Type to search members"
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        />
                                    </div>


                                    {isModalOpen && (
                                        <div className="fixed inset-0 flex items-center justify-center z-10" style={{ maxHeight: '500px', overflowY: 'hidden' }}>
                                            <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px' }}>
                                                <div className="flex justify-end">
                                                    <button onClick={closeModal} className="text-red-500 font-bold">Close</button>
                                                </div>

                                                {/* Member Table inside the modal */}
                                                <TableContainer component={Paper}>

                                                    <Table stickyHeader>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ backgroundColor: '#f3f3f3', padding: '5px', border: '1px solid #ccc' }}>First Name</TableCell>
                                                                <TableCell style={{ backgroundColor: '#f3f3f3', padding: '5px', border: '1px solid #ccc' }}>Last Name</TableCell>
                                                                <TableCell style={{ backgroundColor: '#f3f3f3', padding: '5px', border: '1px solid #ccc' }}>Phone Number</TableCell>
                                                                <TableCell style={{ backgroundColor: '#f3f3f3', padding: '5px', border: '1px solid #ccc' }}>Email</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                            {filteredMembers.map((member) => (
                                                                <TableRow
                                                                    key={member.id}
                                                                    onClick={() => handleRowClick(member)}
                                                                    className="cursor-pointer hover:bg-gray-200"
                                                                    style={{ borderBottom: '1px solid #ddd' }}
                                                                >
                                                                    <TableCell style={{ padding: '4px', border: '1px solid #ccc' }}>{member.firstName}</TableCell>
                                                                    <TableCell style={{ padding: '4px', border: '1px solid #ccc' }}>{member.lastName}</TableCell>
                                                                    <TableCell style={{ padding: '4px', border: '1px solid #ccc' }}>{member.phoneNumber}</TableCell>
                                                                    <TableCell style={{ padding: '4px', border: '1px solid #ccc' }}>{member.email}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                        </div>
                                    )}



                                </div>
                            )}

                            {formData.type === 3 && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="amount">Select Fees</label>
                                    <div className="flex items-center">
                                        <Select
                                            value={formData.feesDescriptionId ? feeslist.find(option => option.value === formData.feesDescriptionId) : null}  // Find the selected value
                                            onChange={(selectedOption) => setFormData(prevData => ({
                                                ...prevData,
                                                feesDescriptionId: selectedOption ? selectedOption.value : null
                                            }))}

                                            options={feeslist}
                                            placeholder="Select Fees"
                                            isSearchable
                                        />
                                    </div>
                                </div>
                            )}
                            {formData.type === 3 && (
                                <div>
                                    <label htmlFor="billDate">Dues</label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                        value={formData.dues}
                                        onChange={handleInputChange}
                                        type="text"
                                        placeholder="Dues"
                                    />
                                </div>
                            )}

                            {formData.type === 3 && (
                                <div className="mt-4" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    <table className="w-full border border-gray-300" style={{ borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ backgroundColor: '#f3f3f3', padding: '5px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1 }}>Bill Date</th>
                                                <th style={{ backgroundColor: '#f3f3f3', padding: '5px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1 }}>Fees Description</th>
                                                <th style={{ backgroundColor: '#f3f3f3', padding: '5px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1 }}>Bill Amount</th>
                                                <th style={{ backgroundColor: '#f3f3f3', padding: '5px', border: '1px solid #ccc', display: 'none', position: 'sticky', top: '0', zIndex: 1 }}>Pending Amount</th>
                                                <th style={{ backgroundColor: '#f3f3f3', padding: '5px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1 }}>Paid Amount</th>
                                                <th style={{ backgroundColor: '#f3f3f3', padding: '5px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1 }}>Balance Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {childdata.map((member) => (
                                                <tr
                                                    key={member.feesId}
                                                    onClick={() => handleRowClick(member)}
                                                    className="cursor-pointer hover:bg-gray-200"
                                                    style={{ borderBottom: '1px solid #ddd' }}
                                                >
                                                    <td style={{ padding: '4px', border: '1px solid #ccc' }}>{formatDateForInput(member.billDate)}</td>
                                                    <td style={{ padding: '4px', border: '1px solid #ccc' }}>{member.description}</td>
                                                    <td style={{ padding: '4px', border: '1px solid #ccc', textAlign: 'right' }}>{member.amount}</td>
                                                    <td style={{ padding: '4px', display: 'none', border: '1px solid #ccc' }}>{member.pendingAmount}</td>
                                                    <td style={{ padding: '4px', border: '1px solid #ccc', textAlign: 'right' }}>{member.paidAmount}</td>
                                                    <td style={{ padding: '4px', border: '1px solid #ccc', textAlign: 'right' }}>{member.balanceAmount}</td>
                                                </tr>
                                            ))}

                                            {/* Calculate the total balance at the bottom */}
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: 'right', padding: '5px', borderTop: '2px solid #ccc' }}>Total Balance:</td>
                                                <td style={{ padding: '5px', borderTop: '2px solid #ccc' }}>
                                                    {/* Calculate the total of balanceAmount */}
                                                    {childdata.reduce((total, member) => total + parseFloat(member.balanceAmount || 0), 0)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}








                            {formData.type === 4 && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="amount">Select Party</label>
                                    <div className="flex items-center">

                                        <Select
                                            value={formData.partyId ? partylist.find(option => option.value === formData.partyId) : null}  // Find the selected value
                                            onChange={(selectedOption) => setFormData(prevData => ({
                                                ...prevData,
                                                partyId: selectedOption ? selectedOption.value : null
                                            }))}
                                            options={partylist}  // Directly pass the array
                                            placeholder="Select Person"
                                            isSearchable
                                        />


                                    </div>
                                </div>
                            )}
                        </div>
                    </div>


                    <div className="w-full mb-1 flex">
                        <div className="w-1/10 mr-8">
                            <label htmlFor="amount">Description</label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                placeholder="Enter Description"
                                rows="2" // Optional: Adjusts the height of the textarea (number of rows)
                            />
                        </div>

                        <div className="w-1/10 mr-2">
                            <label htmlFor="paymentType" className="mr-2">Payment Type</label>


                            <Select
                                value={paymentoptions.find(option => option.value === paymenttype)} // Find the option that matches the current paymentType
                                // onChange={handlePaymentTypeChange}
                                options={paymentoptions}
                                placeholder="Select Payment Type"
                                isDisabled // Set as read-only (disabled)
                            />

                        </div>

                    </div>


                    <div className="w-full flex flex-wrap">


                    </div>

                    {/* Conditionally render Cheque No, Date, and Bank fields */}

                    <div className="w-full flex flex-wrap">
                        {/* Cheque No */}
                        {paymenttype == 1 && (
                            <div className="w-1/10 mr-2">
                                <label htmlFor="amount">Cheque No</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.chequeNo}
                                    onChange={(e) => setChequeNo(e.target.value)}
                                    type="text"
                                    placeholder="Enter ChequeNo"
                                />
                            </div>)}


                        {/* Date */}
                        {paymenttype == 1 && (
                            <div className="w-1/10 mr-2">
                                <label htmlFor="chequedate">Date</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"

                                    value={formatDateForInput(formData.chequeDate)}
                                    onChange={(e) => setChequeDate(e.target.value)}
                                    type="date"
                                    placeholder="Select Date"
                                />
                            </div>
                        )}

                        {(paymenttype == 1 || paymenttype == 2) && (
                            <div className="w-1/10 mr-2">
                                <label htmlFor="amount">Bank</label>
                                <div className="flex items-center">


                                    <Select
                                        value={formData.bankId ? banklist.find(option => option.value === formData.bankId) : null}  // Find the selected value
                                        onChange={(selectedOption) => setFormData(prevData => ({
                                            ...prevData,
                                            bankId: selectedOption ? selectedOption.value : null
                                        }))}
                                        options={banklist}  // Directly pass the array
                                        placeholder="Select Bank"
                                        isSearchable
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                </form>
            </div>


        </Fragment >
    );
}

export default PREdit;




